var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Changelog"},[_c('Dialog',{attrs:{"isShowing":_vm.showChangelog,"useComponent":_vm.ChangelogModal,"componentProps":{},"size":"medium"},on:{"close":function($event){_vm.showChangelog = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }